import React from "react";
import ComCalenderIcon from "../../ui/Icons/ComCalenderIcon";
import { Box, Button, Stack, Typography } from "@mui/material";
import styles from "../../styles/components/duplication.data-calander.module.scss";
import AlltimemenuTwo from "../../ui/Customdropdown/AlltimemenuTwo";
import useCalenderFilter from "../../hooks/useCalenderFilter";
import { useEffect } from "react";
import CalenderDate from "../../pages/Calender";
import dayjs from "dayjs";

export default function ManagerDuplicationsvdoDataCalender({
    totalVideos,
    setCalenderDate,
}) {
    //calender functions
    const calenderId = "calendar-input-home";
    const {
        calenderFilter,
        DateFilterRangeList,
        calenderFilterShowValue,
        changeCalenderFilter,
        calenderOpen,
        resetCalender,
        confirmCalender,
        confirmedCalenderValue,
        calenderValue,
        setCalenderValue,
        toggleCalender,
        closeCalender,
        confirmCalenderTwo,
        dateRangeFilter: {
            dateRangeFilterAnchor,
            openedDateRangeFilter,
            handleOpenDateRangeFilter,
            handleCloseDateRangeFilter,
        },
    } = useCalenderFilter({
        containerId: calenderId,
    });
    useEffect(() => {
        const startDate = dayjs(confirmedCalenderValue?.[0]).format(
            "DD-MM-YYYY"
        );
        const endDate = dayjs(confirmedCalenderValue?.[1]).format("DD-MM-YYYY");
        setCalenderDate({ from: startDate, to: endDate });
    }, [confirmedCalenderValue]);
    return (
        <>
            <Stack
                direction={"row"}
                alignItems={"center"}
                flexWrap={"wrap"}
                justifyContent={"space-between"}
                className={`${styles.calenderHeader} ${styles.pendingCalenderHeader}`}
            >
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    flexWrap={"wrap"}
                    className={styles.calendarData}
                >
                    <Typography variant="body1" className={`${styles.dataTxt} ${calenderFilter?.name?.length ? '' : `${styles.datePeriod}`}`}>
                        Showing videos for {calenderFilter?.name?.length ? ("") : ("the period from")}
                    </Typography>
                    <AlltimemenuTwo
                        dateRangeFilterAnchor={dateRangeFilterAnchor}
                        DateFilterRangeList={DateFilterRangeList}
                        openedDateRangeFilter={openedDateRangeFilter}
                        handleCloseDateRangeFilter={handleCloseDateRangeFilter}
                        changeCalenderFilter={changeCalenderFilter}
                        calenderFilter={calenderFilter}
                        handleOpenDateRangeFilter={handleOpenDateRangeFilter}
                    />
                    <Typography variant="body2" className={`${styles.datetxt} ${calenderFilter?.name?.length ? '' : `${styles.textBlue}`}`}>
                        {calenderFilter?.name?.length ? (
                            `(${dayjs(confirmedCalenderValue?.[0]).format(
                                "LL"
                            )} - ${dayjs(confirmedCalenderValue?.[1]).format(
                                "LL"
                            )})`
                        ) : (
                            <>
                                {/* {"the period from "} */}
                                {confirmedCalenderValue?.[0] ? (
                                    <span className="dayList">
                                        {dayjs(
                                            confirmedCalenderValue?.[0]
                                        ).format("LL")}
                                    </span>
                                ) : null}
                                {" to "}
                                {calenderValue?.[1] ? (
                                    <span className="dayList">
                                        {dayjs(
                                            confirmedCalenderValue?.[1]
                                        ).format("LL")}
                                    </span>
                                ) : null}
                            </>
                        )}
                    </Typography>
                    {calenderFilter?.name !== "All time" ? (
                        <span className="reset_picker" onClick={resetCalender}>
                            <svg
                                width="11"
                                height="11"
                                viewBox="0 0 11 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    stroke-linejoin="round"
                                ></path>
                                <path
                                    d="M4.22705 6.7832L6.77263 4.23762"
                                    stroke="currentColor"
                                    strokeWidth="0.8"
                                    strokeLinecap="round"
                                    stroke-linejoin="round"
                                ></path>
                                <path
                                    d="M6.77263 6.76238L4.22705 4.2168"
                                    stroke="currentColor"
                                    strokeWidth="0.8"
                                    strokeLinecap="round"
                                    stroke-linejoin="round"
                                ></path>
                            </svg>
                            reset
                        </span>
                    ) : null}
                </Stack>
                <Box className={styles.btnGroup}>
                        <CalenderDate confirmCalender={confirmCalenderTwo} />
                    {/* <Typography variant="body2">
                        <span>All videos:</span>
                        {totalVideos}
                    </Typography> */}
                </Box>
            </Stack>
        </>
    );
}
